import React from 'react'

const 학습지교재생성제한모달 = () => {
  return (
    <>
      무료체험 중 학습지&교재 생성 횟수를 모두 사용하셨네요.
      <br />
      정식가입 하시면 학습지와 교재 생성을 무제한으로 이용하실 수 있습니다.
      <br />
      담당 컨설턴트가 빠르게 연락하여 정식가입을 도와드릴게요.
    </>
  )
}

export default 학습지교재생성제한모달
